<template>
  <div class="wrapper" v-loading="showLoading">
    <common-header url="channelIssuance" />

    <table class="table center">
      <mer-base-info v-model="showAddress" :details="details" readonly />
      <mer-operators v-model="showAddress" :details="details" readonly />

      <!-- 支付终端 -->
      <tr>
        <th colspan="10">支付终端录入</th>
      </tr>
      <tr>
        <td>通道号</td>
        <td>
          <el-input v-model="terminal.paymentChannelNo" readonly />
        </td>
        <td>通道商</td>
        <td>
          <el-input v-model="terminal.paymentChannelName" readonly />
        </td>
        <td>提供设备</td>
        <td>
          <common-select
            v-model="terminal.provideDevice"
            :list="isSelectList"
          />
        </td>
        <td>终端序列号</td>
        <td>
          <el-input v-model="terminal.a" placeholder="请输入" />
        </td>
        <td>SIM卡号</td>
        <td>
          <el-input v-model="terminal.b" placeholder="请输入" />
        </td>
      </tr>
      <tr>
        <td>PIN算法标识</td>
        <td>
          <el-input readonly :value="terminal.pinAlgorithmId" />
        </td>
        <td>加密算法</td>
        <td>
          <el-input readonly :value="terminal.encryptAlgorithm" />
        </td>
        <td>秘钥方式</td>
        <td>
          <el-input readonly :value="terminal.secretKeyWay" />
        </td>
        <td>秘钥名称</td>
        <td>
          <el-input readonly :value="terminal.secretKeyName" />
        </td>
        <td>秘钥操作</td>
        <td></td>
      </tr>
      <tr>
        <td>保理挂接</td>
        <td>
          <common-select
            v-model="terminal.factoringHookUp"
            :list="isSelectList"
          />
        </td>
        <td>挂接比例</td>
        <td>
          <el-input
            v-model="terminal.factoringRatio"
            :readonly="terminal.factoringHookUp != 0"
          />
          <span class="editWord">%</span>
        </td>
        <td>手续费减免</td>
        <td>
          <common-select v-model="terminal.feeReduction" :list="feeReduction" />
        </td>
        <td>减免比例</td>
        <td>
          <el-input
            v-model="terminal.feeReductionRatio"
            :readonly="terminal.feeReduction != 1"
          />
          <span class="editWord">%</span>
        </td>
        <td>行别</td>
        <td>
          <el-input v-model="terminal.bankType" />
        </td>
      </tr>
      <tr>
        <td>开户行</td>
        <td>
          <el-input v-model="terminal.accountType" />
        </td>
        <td>联行号</td>
        <td>
          <el-input v-model="terminal.bankCode" />
        </td>
        <td>账号</td>
        <td colspan="5">
          <el-input v-model="terminal.accountCardNo" />
        </td>
      </tr>
      <tr>
        <td>微信</td>
        <td>
          <el-input v-model="terminal.weChatPay" />
          <span class="editWord">%</span>
        </td>
        <td>支付宝</td>
        <td>
          <el-input v-model="terminal.aliPay" />
          <span class="editWord">%</span>
        </td>
        <td>云闪付</td>
        <td>
          <el-input v-model="terminal.quickPass" />
          <span class="editWord">%</span>
        </td>
        <td>京东支付</td>
        <td>
          <el-input v-model="terminal.jingDongPay" />
          <span class="editWord">%</span>
        </td>
        <td>POS收单</td>
        <td>
          <el-input v-model="terminal.pos" />
          <span class="editWord">%</span>
        </td>
      </tr>
      <tr>
        <td>更换历史</td>
        <td colspan="9" style="height:100px">
          <p
            class="change-history-item"
            v-for="history of changeHistory"
            :key="history.id"
          >
            更换通道：{{ history.channelName }} 更新时间：{{
              history.createTime
            }}
            操作人：{{ history.username }}
          </p>
        </td>
      </tr>

      <tr>
        <th colspan="10">相关资质</th>
      </tr>
      <tr>
        <td colspan="10">
          <!-- 相关资质 -->
          <upload-file
            readonly
            v-for="item of imgList"
            v-model="details[item.key]"
            :previewList="imgList.map(el => details[el.key])"
            :name="item.name"
            :key="item.key"
          ></upload-file>
        </td>
      </tr>
    </table>

    <div class="action-buttons">
      <button class="action-button blue" @click="updateUnionPayment">
        通道发行
      </button>
    </div>
  </div>
</template>

<script>
import MerBaseInfo from '@/components/DetailsMerchant/BaseInfo'
import MerOperators from '@/components/DetailsMerchant/Operators'
export default {
  components: {
    MerBaseInfo,
    MerOperators
  },

  props: ['merId'],

  data() {
    return {
      showLoading: true,
      showAddress: false,
      details: {},
      terminal: {}, // 支付终端信息

      SIMList: [], // SIM卡列表下拉框
      POSList: [], // POS卡列表下拉框
      changeHistory: [], // 更换记录
      isSelectList: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
      feeReduction: [
        { value: 0, label: '无' },
        { value: 1, label: '保理交易前置' }
      ],
      imgList: [
        {
          key: 'urlBusine',
          name: '营业执照'
        },
        {
          key: 'urlCardFront',
          name: '法人身份证（正面）'
        },
        {
          key: 'urlCardBack',
          name: '法人身份证（背面）'
        },
        {
          key: 'urlCashier',
          name: '收银台'
        },
        {
          key: 'urlDoor',
          name: '门头照'
        },
        {
          key: 'urlShop',
          name: '店铺照片'
        },
        {
          key: 'urlFacialFeature',
          name: '脸部特征'
        }
      ] // 预览图片列表
    }
  },

  created() {
    this.getMerchantDetails()
    this.getQueryUnionPayment() // 支付终端信息
    this.getChannelHistory()
  },

  methods: {
    getMerchantDetails() {
      const {
        merId,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T2/channelIssuance/getMerchantDetails'

      dispatch(dispatchEvent, { merId }).then(res => {
        this.details = res
        this.showLoading = false
      })
    },

    // 获取支付终端信息
    getQueryUnionPayment() {
      const {
        merId,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T2/channelIssuance/getQueryUnionPayment'

      dispatch(dispatchEvent, { merId }).then(res => {
        delete res.status
        this.terminal = res
      })
    },

    // 获取通道更换记录
    getChannelHistory() {
      const {
        merId,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T2/channelIssuance/getChannelHistory'

      dispatch(dispatchEvent, { merId }).then(res => (this.changeHistory = res))
    },

    // 通道发行
    updateUnionPayment() {
      const {
        merId,
        terminal,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T2/channelIssuance/updateUnionPayment'

      dispatch(dispatchEvent, { merId, ...terminal }).then(({ status }) => {
        if (status === 200) {
          this.$alert('操作成功').then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/css/Common/detailsTable.scss';

.change-history-item {
  line-height: 24px;
}
</style>